import IntegrationsCard from './IntegrationsCard';

export default IntegrationsCard;